import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  FullSizeCenteredFlexBox,
  CenteredFlexBox,
} from '../../../Components/FlexBox';
import IconButton from '../../../Components/Button/IconButton';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

const Stage = function Stage({
  title,
  value,
  color,
  width,
  percentageValue,
  description,
}) {
  return (
    <Paper
      sx={{
        height: `${percentageValue}%`,
        minHeight: '72px',
        width,
        backgroundColor: color,
      }}
    >
      <FullSizeCenteredFlexBox justifyContent="space-between" padding="16px">
        <CenteredFlexBox gap="16px">
          <CenteredFlexBox
            justifyContent="center"
            sx={{
              backgroundColor: '#fff',
              minWidth: '50px',
              borderRadius: '50px',
            }}
          >
            <Typography color={color} variant="h6">
              {value?.toString()}
            </Typography>
          </CenteredFlexBox>
          <CenteredFlexBox gap="6px">
            <Typography variant="h6" sx={{
              color: "#fff"
            }}>
              {title}
            </Typography>
            {description && (
              <IconButton
                id="stage-description-help"
                size="small"
                title={description}
                tooltipProps={{
                  placement: 'top',
                  arrow: true,
                  componentsProps: {
                    tooltip: {
                      sx: {
                        padding: '8px',
                        fontSize: '1.2rem',
                      },
                    },
                  },
                }}
              >
                <HelpOutlineRoundedIcon />
              </IconButton>
            )}
          </CenteredFlexBox>
        </CenteredFlexBox>
        <CenteredFlexBox
          justifyContent="center"
          sx={{
            backgroundColor: 'rgba(180, 180, 180, 0.3)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            minWidth: '60px',
            borderRadius: '50px',
          }}
        >
          <Typography variant="subtitle1" sx={{
            color: "#fff"
          }}>
            {percentageValue}%
          </Typography>
        </CenteredFlexBox>
      </FullSizeCenteredFlexBox>
    </Paper>
  );
};

export default Stage;
